module.exports = __webpack_public_path__ + "static/media/005-Wechseln_ID_8.5a46e2ac.mp3";